import axios from 'axios';
import Config from 'Config';
import { createSignedRequest } from 'utils/createSignedRequest';
import { API_URL } from '../utils/constants';

/**
 * Asks the API to read the drawing with the AI. Answers the floorplan row
 * with its `aiReading`; a refusal at the assistant's door, an image problem
 * or a reading that failed is thrown as the axios error, whose response
 * carries `{ code, message }`.
 * @param {string} projectId
 * @param {string} floorplanId
 * @param {Object} [body] `levelMarks` found on the image (findLevelMarks)
 *   for their values to be read too, and `levelMarksOnly` to read only
 *   those, adding them to the reading the row has
 */
export const postFloorplanAiReading = async (
  projectId,
  floorplanId,
  body = {}
) => {
  const apiPath = `projects/${projectId}/floorplans/${floorplanId}/ai-reading`;

  const request = {
    url: `${API_URL}/${apiPath}`,
    host: process.env.REACT_APP_WORK_CALENDAR_API_URL,
    path: apiPath,
    method: 'POST',
    region: Config.AWS_REGION,
    service: 'execute-api',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
    data: body,
  };

  const signedRequest = await createSignedRequest(request);
  const response = await axios(signedRequest);
  return response.data;
};
